<template>
  <div class="footer">
    <footer>
      <div class="row d-print-none">
        <div class="col disclaimer-link">
          <router-link class="assumption-button col" :to="{ name: 'Assumptions', params: {activeTab: 'disclaimer' } }" tabindex="0">Assumptions and disclaimer</router-link>
        </div>
        <div class="col afsl">
          <p>{{ pageContent.footerCompanyName }}</p>
        </div>
        <div class="col build-by-link">
          <a class="g-logo" href="//gallagherdigital.com.au" target="_blank" :aria-label="'Gallagher '+new Date().getFullYear()"></a>
          <a href="//gallagherdigital.com.au" target="_blank" :aria-label="'Gallagher '+new Date().getFullYear()">
            © <span>Gallagher</span> {{new Date().getFullYear()}}
          </a>

        </div>
      </div>


      {{ msg }}
    </footer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'CustomFooter',
  props: {
    msg: String
  },
  computed: {
		...mapGetters(["pageContent"]),
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
